export default function(params, node) {
  var self = this;
  self.$el = $(node);

  self.program = ko.observable();
  self.skill_levels = ko.observableArray([]);
  self.master_records = ko.observableArray([]);
  self.selected_courses = ko.observableArray([]);

  self.defaults = {};
  self.editing = ko.observable(false);
  self.shouldDelete = ko.observable(false);
  self.isAddingProgramSection = ko.observable(false);
  self.saving = ko.observable(false);

  self.config = _.extend({}, self.defaults, params);

  self.newProgramSection = ({
    title: ko.observable().extend({required: true}),
    content: ko.observable(),
    id: ko.observable(),
    order: ko.observable(),
    isNew: true
  });

  self.init = function() {
    var mapped = ko.mapping.fromJSON(params);
    self.program(mapped.program);
    self.skill_levels(mapped.skill_levels());
    self.master_records(mapped.master_records());

    _.each(self.program().course_master_record_ids(), function(id, idx) {
      var found = ko.utils.arrayFirst(self.master_records(), function(_item) {
        return _item.id() == id;
      });
      if (found) {
        found.order = ko.observable(idx + 1);
      }
      self.selected_courses.push(found);
    });

    self.initDropZones();
    self.initSortableTable();

    self.selected_courses.subscribe(function(changes) {
      _.each(changes, function(change) {
        if ((change.status === 'added' || change.status === 'deleted')
            && typeof(change.value.order) != 'undefined' && self.selected_courses().length > 0 ) {
          self.update_selected_order();
          console.log(change.status);
        }
      });
    }, null, 'arrayChange');

    setTimeout(function() {
      (new Kadenze.KdForms()).update();
    }, 200);
  };

  self.saveNewSection = function(skipSave) {
    var clientErrors = ko.validation.group(self.newProgramSection.title);
    if (clientErrors().length === 0 || (clientErrors().length === 1 && clientErrors()[0] === null)) {
      self.program().syllabus_program_sections.push(self.newProgramSection);
      self.cancelNewSection();
      if (skipSave !== true) {
        self.save(true);
      }
    } else {
      clientErrors.showAllMessages();
      new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: 'Please fix all validation errors before saving.' }));
      return false;
    }
    return true;
  };

  self.removeSection = function(id) {
    return function() {
      var sections = self.program().syllabus_program_sections();
      var index = -1;
      var existing = null;
      _.each(sections, function(section, _index){
        if (section.id() == id) {
          index = _index;
          existing = section;
        }
      });
      if (index > -1) {
        existing._destroy = true;
        sections[index] = existing;
        self.program().syllabus_program_sections(sections);
        self.save(true);
      }
    };
  };

  self.update_selected_order = function() {
    _.each(self.selected_courses(), function(course, idx) {
      course.order(idx + 1);
    });
  };

  self.initSortableTable = function() {
    var $tableEle = $('#linked_courses_sortable');
    $tableEle.sortable({
      handle:'.display-table__sort-handle',
      start: function(e, ui) {
        ui.item.data('startindex', ui.item.index());
      },
      stop: function(e, ui) {
        var startIndex = parseInt(ui.item.data('startindex'), 10);
        var newIndex = ui.item.index();
        var item = self.selected_courses()[startIndex];
        //remove item from the old position
        self.selected_courses.remove(function(record) {
          return record.order() === item.order();
        });

        //ko rebinds the array so remove duplicate item from the DOM
        ui.item.remove();

        //insert item back into the list at the new position
        self.selected_courses.splice(newIndex, 0, item);

        // fire off order query
        self.sortProgramCourses($tableEle);
      }
    });
  };

  self.sortProgramCourses = function($ele) {
    var self = this;
    var url = Kadenze.Routes.sort_master_records_admin_program_path(self.program().id());
    var data = _.map(self.selected_courses(), function(item, idx) {
      return {id: item.id(), order: idx};
    });
    data = { master_records: data };
    $.ajax({
      url: url,
      type: 'POST',
      data: data,
      beforeSend: function(xhr, settings) {
        // self.saving(true);
        Kadenze.UIUtil.showLoadingIndicator();
      },
      success: function(data, textStatus, xhr) {

      },
      error: function(xhr, textStatus, errorThrown) {
        $ele.sortable('cancel');
        Kadenze.Notice.error({message: 'An unexpected error occurred. Please try again later.'});
      },
      complete: function(xhr, textStatus) {
        // self.saving(false);
        Kadenze.UIUtil.hideLoadingIndicator();
      }
    });
  };

  self.addNewSection = function() {
    self.newProgramSection.title(null);
    self.newProgramSection.title.isModified(false);
    self.newProgramSection.content(null);
    var maxOrder = Math.max.apply(null, _.map(self.program().syllabus_program_sections(), function(section){
      return Math.max(section.order(), -1);
    })) || -1;
    self.newProgramSection.order(maxOrder + 1);
    self.isAddingProgramSection(true);
  };

  self.cancelNewSection = function() {
    self.isAddingProgramSection(false);
  };

  self.initDropZones = function() {
    var $dropzones = $('.js-program-dz');

    $dropzones.each(function() {

      var templateConfig = $(this).data('dz-config');
      templateConfig['dropFilesTitle'] = Kadenze.I18n.t('drop_file_editor.drop_file_title');
      templateConfig['dragAndDrop'] = Kadenze.I18n.t('drop_file_editor.drag_and_drop');
      templateConfig['browseFiles'] = Kadenze.I18n.t('drop_file_editor.browse_files');
      templateConfig['dimentionLabel'] = Kadenze.I18n.t('drop_file_editor.dimensions_label');
      templateConfig['maxFilesizeLabel'] = Kadenze.I18n.t('drop_file_editor.max_file_size');
      templateConfig['fileTypesLabel'] = Kadenze.I18n.t('drop_file_editor.file_types');
      templateConfig['optionalLable'] = Kadenze.I18n.t('drop_file_editor.optional');

      let $this = $(this),
        uploadUrl = Kadenze.Routes.temp_image_upload_path(),
        observableRef = $this.data('dz-name'),
        message = JST['templates/dropzone-generic'](templateConfig),
        aspectRatio = parseFloat($this.data('aspect-ratio'), 10);

      let options = {
        dzName: templateConfig.title,
        previewable: true,
        dzPreview: JST['templates/dropzone-generic-img-preview']({
          previewable: true,
          nameLabel: Kadenze.I18n.t('file_preview.name'),
          sizeLabel: Kadenze.I18n.t('file_preview.size'),
          previewLabel: Kadenze.I18n.t('file_preview.preview'),
          removeLabel: Kadenze.I18n.t('file_preview.remove_file'),
          fileUploadProgressLabel: Kadenze.I18n.t('file_preview.file_upload_progress')
        }),
        maxFilesize: templateConfig.maxFilesize,
        acceptedFiles: templateConfig.acceptedFiles,
        thumbnailWidth: 300,
        thumbnailHeight: 300/aspectRatio,
        cropOptions: {
          aspectRatio: aspectRatio
        }
      };

      var curFileObj = {
        path: self.program()[observableRef].url()
      };

      var callbacks = {
        success: function(_file, response){
          var obs = self.program()['remote_' + observableRef + '_url'];
          if (obs) {
            obs(response.path);
          } else {
            self.program()['remote_' + observableRef + '_url'] = ko.observable(response.path);
          }
        },

        removedfile: function(file){}
      };

      var dz = new Kadenze.ImageDropZone($this, message, uploadUrl, callbacks, curFileObj, options);

      $this.data('dz', dz);
    });

  };

  self.preview = function() {
    var request = self.save(true);
    request.done(function() {
      window.location = Kadenze.Routes.program_path(self.program().id(), {preview: true, exit_path: encodeURI(window.location.pathname)});
    });
  };

  self.destroy = function(vm) {
    Kadenze.UIUtil.confirmAction('Are you sure you want to delete this program?', function() {
      if (self.program().id()) {
        var request = new Kadenze.AjaxRequest({
          type: 'DELETE',
          url: Kadenze.Routes.admin_program_path(self.program().id()),
          loadingIndicator: {
            container: self.$el,
            positionTop: 'fixed'
          }
        });

        request.done(function(response) {
          new Kadenze.Notice.success({ message: response.message });
          Kadenze.Request.pjax({url: Kadenze.Routes.admin_programs_path()});
        });

        request.fail(function(response) {
          console.warn('Failed saving program: ', response);
          var message = response.responseJSON ? response.responseJSON.message : Kadenze.I18n.t('notice.unexpected_error');
          new Kadenze.Notice.error({ message: message });
        });

      } else {
        Kadenze.Request.pjax({url: Kadenze.Routes.admin_programs_path()});
      }
    });

  };

  self.publish = function(vm) {
    if (self.isAddingProgramSection()) {
      var isValid = self.saveNewSection(true);
      if (!isValid) { return false; }
    }
    self.program().status('published');
    self.save();
  };

  self.unpublish = function() {
    self.program().status('draft');
    self.save();
  };

  self.save = function(skipRedirect) {
    if (self.isAddingProgramSection()) {
      var isValid = self.saveNewSection(true);
      if (!isValid) { return false; }
    }
    self.prepData();
    var url, method;
    if (self.program().id() == null) {
      url = Kadenze.Routes.admin_programs_path();
      method = 'POST';
    } else {
      url = Kadenze.Routes.admin_program_path(self.program().id());
      method = 'PATCH';
    }

    var data = self.dataForSaving();

    var request = new Kadenze.AjaxRequest({
      type: method,
      url: url,
      data: { program: data },
      loadingIndicator: {
        container: self.$el,
        positionTop: 'fixed'
      }
    });

    request.done(function(response) {
      new Kadenze.Notice.success({ message: response.message });
      var programData = JSON.parse(response.program)
      self.program().id(programData.program.id);
      self.program().syllabus_program_sections(ko.mapping.fromJS(programData.program.syllabus_program_sections)());
      if (!skipRedirect) {
        Kadenze.Request.pjax({url: Kadenze.Routes.admin_programs_path()});
      }
    });

    request.fail(function(response) {
      console.warn('Failed saving program: ', response);
      var message = response.responseJSON.message
      new Kadenze.Notice.error({ message: message });
    });

    return request;
  };

  self.dataForSaving = function(opts) {
    var obj = ko.mapping.toJS(self.program);

    obj.syllabus_program_sections_attributes = ko.mapping.toJS(self.program().syllabus_program_sections());

    delete obj.syllabus_program_sections; // Remove this line if you want to keep the original sections

    return $.extend(true, {}, obj, opts);
  };

  self.prepData = function() {
    self.program().course_master_record_ids(_.map(self.selected_courses(), function(item) {
      return item.id();
    }));

    self.program().send_completion_email(!_.isEmpty(self.program().completion_email()));
  };

  self.init();

  return self;
}
